export function waitForSeconds(seconds: number): Promise<void> {
    if (seconds > 100) {
        console.warn('WARNING!: YOU PASSED IN A NUMBER GREATER THAN 100, Are you sure you want to do this? This function takes in seconds, not milliseconds.');
    }
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}



// WEBPACK FOOTER //
// ./src/util/waitForSeconds.ts